import {Component, Inject, OnInit} from '@angular/core';
import {MessagePopup} from '@core/models';
import {Router} from '@angular/router';
import {RouterLinks} from '@core/constants';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './subscribe-modal.component.html',
    styleUrls: ['./subscribe-modal.component.scss'],
    imports: [
        MatButtonModule
    ]
})
export class SubscribeModalComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MessagePopup,
    private router: Router,
    private dialogRef: MatDialogRef<SubscribeModalComponent>) {
  }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  redirect(): void {
    this.closeModal();
    this.router.navigate([RouterLinks.ACCOUNT]);
  }

}
